import React, { ClipboardEvent } from 'react'
import { FormErrorMessage, Input } from '@chakra-ui/react'
import { useFormContext, Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { PHONE_NUMBER_PATTERN } from 'constants/common'
import { formatUSPhoneNumber } from 'utils/common'

const FormPhoneInput = () => {
  const {
    control,
    formState: { errors },
    reset
  } = useFormContext()

  function onPastePhoneInput(event: ClipboardEvent<HTMLInputElement>): void {
    const clipboardData: DataTransfer = event.clipboardData
    const pastedPhoneNumber: string = clipboardData.getData('Text').replace(/\n/g, '')
    if (pastedPhoneNumber.startsWith('+1')) {
      const phoneNumber: string = formatUSPhoneNumber(pastedPhoneNumber)
      reset({ phoneNumber })
    }
  }

  return (
    <>
      <Controller
        name={'phoneNumber'}
        control={control}
        rules={{
          required: 'Phone number is required',
          pattern: {
            value: PHONE_NUMBER_PATTERN,
            message: 'Invalid Phone Number'
          }
        }}
        render={({ field: { onChange, value } }) => (
          <Input
            as={NumberFormat}
            value={value}
            onChange={onChange}
            format="(###) ###-####"
            placeholder={'Enter Your Phone Number'}
            marginTop="0 !important"
            height={{ base: '48px', lg: '40px' }}
            fontSize={{ base: 'lg', lg: 'md' }}
            onPaste={onPastePhoneInput}
          />
        )}
      />
      <FormErrorMessage marginTop="8px !important" display={{ base: 'block', md: 'none', lg: 'block' }}>
        {errors?.phoneNumber && errors?.phoneNumber?.message}
      </FormErrorMessage>
    </>
  )
}

export default FormPhoneInput
